/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function (global) {
    'use strict';

    var previousPagination = global.Pagination;

    function Pagination(options) {
        var options = options || {};
        var template;
        var $container;
        var source;
        var context;
        var callback;
        var $filterOrder;
        var $resultsData;
        var $resultsOneData;
        var $startIndex;
        var $endIndex;
        var $totalResults;

        function init() {
            // DevComment: console.group('MODULE INITIALIZATION: Pagination');
            // Check that callback is not undefined and it is a function
            callback = options.callback;
            $container = options.$container;

            source = $(options.hbtpl).html();
            template = Handlebars.compile(source);
            $filterOrder = $('.js-wrap-fltr-order');
            $resultsData = $('.js-results-data');
            $resultsOneData = $('.js-results-one-data');
            $startIndex = $resultsData.add($resultsOneData).find('.js-start-index');
            $endIndex = $resultsData.add($resultsOneData).find('.js-end-index');
            $totalResults = $resultsData.add($resultsOneData).find('.js-total-results');

            // Added handlebar helper to evaluate equal for two values
            Handlebars.registerHelper('ifEq', function (val1, val2, options) {
                if (val1 === val2) {
                    return options.fn(this);
                } else {
                    return options.inverse(this);
                }
            });

            // Added handlebar helper to evaluate minor values
            Handlebars.registerHelper('ifMinEq', function (val1, val2, options) {
                if (val1 <= val2) {
                    return options.fn(this);
                }
            });

            setContex();
            // render();

            // Btn see more
            $container.on('click', '.js-see-more', function () {
                var page;

                page = context.pageIndex;
                page++;
                callback('pageNumb', page);
            });

            // Btn go to page
            $container.on('click', '.js-page', function (event) {
                var page;
                event.preventDefault();

                page = $(event.target).data('page');
                callback('pageNumb', page);
            });

            // Btn go to previous page
            $container.on('click', '.js-btn-prev', function (event) {
                var page;
                event.preventDefault();

                page = context.pageIndex;
                if (page !== 1) {
                    page--;
                    callback('pageNumb', page);
                }
            });

            // Btn go to next page
            $container.on('click', '.js-btn-next', function (event) {
                var page;
                event.preventDefault();

                page = context.pageIndex;
                if (page !== context.totalPages) {
                    page++;
                    callback('pageNumb', page);
                }
            });

            // Btn filter by amount of pages
            $container.on('change', '.js-results-by-page', function () {
                callback('resultsByPage', this.value);
            });
        }

        function configPag(totalRecords, pageIndex, pageResultSize) {
            var totalPages;
            var startPage;
            var endPage;
            var startIndex;
            var endIndex;
            var pages = [];

            // Get total pages
            totalPages = context.totalPages;

            if (totalPages <= 6) {
                // Less than 6 total pages so show all
                startPage = 1;
                endPage = totalPages;
            } else {
                // More than 6 total pages so calculate start and end pages
                if (pageIndex <= 4) {
                    startPage = 1;
                    endPage = 6;
                } else if (pageIndex + 2 >= totalPages) {
                    startPage = totalPages - 5;
                    endPage = totalPages;
                } else {
                    startPage = pageIndex - 3;
                    endPage = pageIndex + 2;
                }
            }

            // Create array with initial and final page
            for (var i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            // Calculate start and end item indexes
            if (pageIndex !== totalPages) {
                startIndex = (pageIndex - 1) * pageResultSize;
            } else {
                startIndex = totalRecords - pageResultSize;
            }
            endIndex = startIndex + pageResultSize;

            // Show init index from a value included in the items
            startIndex += 1;

            // Hide filter order when totalRecords is equal to 1
            if (totalRecords <= 1) {
                $filterOrder.hide();
            } else {
                $filterOrder.show();
            }

            setResultsData(startIndex, endIndex, totalRecords);

            // Return pagination config values
            return {
                pages: pages,
                startIndex: startIndex,
                endIndex: endIndex
            };
        }

        function setResultsData(startIndex, endIndex, totalRecords) {
            $startIndex.text(startIndex);
            $endIndex.text(endIndex);
            $totalResults.text(totalRecords);
            $resultsOneData.hide();

            if (totalRecords === 0) {
                $resultsData.hide();
            } else if (totalRecords === 1) {
                $resultsData.hide();
                $resultsOneData.show();
            } else {
                $resultsData.show();
            }
        }

        function setContex() {
            context = options.params;
            context.resources = options.resources;
            context.configPag = configPag(context.totalRecords,
                                          context.pageIndex,
                                          context.pageResultSize);
            // DevComment: console.log(context);
            // DevComment: console.groupEnd();
            render();
        }

        function render() {
            var html;

            html = template(context);
            $container.empty();
            $container.append(html);
        }

        function update(params, resources) {
            context = params;
            context.resources = resources;
            context.configPag = configPag(context.totalRecords,
                                          context.pageIndex,
                                          context.pageResultSize);
            render();
        }

        init();

        return {
            update: update
        }
    }

    Pagination.noConflict = function noConflict() {
        global.Pagination = previousPagination;
        return Pagination;
    };

    global.Pagination = Pagination;
}(this);
